export function getTurnstileSiteKey(): string | null {
  const key = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim();
  return key ? key : null;
}

export function isCaptchaEnabled(): boolean {
  return getTurnstileSiteKey() !== null;
}

export function normalizeCaptchaToken(captchaToken: string | null | undefined): string | null {
  const token = captchaToken?.trim();
  return token ? token : null;
}

export function buildCaptchaOptions(
  captchaToken: string | null | undefined,
): { captchaToken: string } | undefined {
  const token = normalizeCaptchaToken(captchaToken);
  return token ? { captchaToken: token } : undefined;
}

export type AuthCaptchaErrorLike = {
  code?: string | null;
  message?: string | null;
};

export function isCaptchaVerificationError(error: AuthCaptchaErrorLike | null | undefined): boolean {
  if (!error) return false;

  const code = error.code?.toLowerCase();
  if (code === "captcha_failed") return true;

  const message = error.message?.toLowerCase() ?? "";
  return message.includes("captcha") || message.includes("turnstile");
}
